module.exports = __webpack_public_path__ + "img/message.3f5e37c9.svg";